export default __webpack_public_path__ + "static/media/whatsOnMyiPhone.346ad3db.md";